import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import * as React from 'react';
import Report28DayViewModel from "./ViewModels/Report28DayViewModel";

interface IProps {
    row: Report28DayViewModel;
}
export default function Document28DayRow(props: IProps) {
    const { row } = props;

    return (
        <TableRow>
            <TableCell>{row.client}</TableCell>
            <TableCell>{row.documentType}</TableCell>
            <TableCell>{row.documentNumber}</TableCell>
            <TableCell>{row.carriedOutOn && new Date(row.carriedOutOn).toLocaleDateString('en-gb')}</TableCell>
            <TableCell>{new Date(row.draftedDate).toLocaleDateString('en-gb')}</TableCell>
            <TableCell>{row.draftedBy}</TableCell>
            <TableCell>{row.compiledDate && new Date(row.compiledDate).toLocaleDateString('en-gb')}</TableCell>
            <TableCell>{row.compiledBy}</TableCell>
            <TableCell>{row.certifiedDate && new Date(row.certifiedDate).toLocaleDateString('en-gb')}</TableCell>
            <TableCell>{row.certifiedBy}</TableCell>
        </TableRow >
    );
}